<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zZVbWe/tc-custom/9781615192465.jpg?1705777965716" alt="This image is the cover for the book Most Wanted Particle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Most Wanted Particle
      </h1>
      <p class="bookDescription body article font2">
        <b>An accessible account of the work leading up to the monumental discovery of the Higgs boson, from one of the physicists who was there.</b><br/><br/> Particle physics as we know it depends on the Higgs boson: It’s the missing link between the birth of our universe—as a sea of tiny, massless particles—and the tangible world we live in today. But for more than 50 years, scientists wondered: <i>Does it exist?</i><br/>  <br/> Physicist Jon Butterworth was at the frontlines of the hunt for the Higgs at CERN’s Large Hadron Collider—perhaps the most ambitious experiment in history. In <i>Most Wanted Particle</i>, he gives us the first inside account of that uncertain time, when an entire field hinged on a single particle, and life at the cutting edge of science meant media scrutiny, late-night pub debates, dispiriting false starts in the face of intense pressure, and countless hours at the collider itself. As Butterworth explains, our first glimpse of the elusive Higgs brings us a giant step closer to understanding the universe—and points the way to an entirely new kind of physics.<br/><br/><b>Praise for <i>Most Wanted Particle</i></b><br/><br/><b>“Butterworth is an insider’s insider. His narrative seethes with insights on the project’s science, technology and “tribes,” as well as his personal (and often amusing) journey as a frontier physicist.” —<i>Nature</i></b><br/><br/><b>“A vivid account of what the process of discovery was really like for an insider.” —Peter Higgs, winner of the Nobel Prize in Physics</b><br/><br/><b>“If you want to know why the discovery of the Higgs boson matters, read this book!” —Brian Cox, author of <i>Why Does E=mc2?</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon Butterworth, Lisa Randall
      </h2>
      
      <p class="authorDescription body article"><B>Jon Butterworth</B> is a professor in the Department of Physics and Astronomy at University College London and a member of the ATLAS collaboration at CERN&rsquo;s Large Hadron Collider in Geneva, Switzerland. He writes the <I>Life and Physic</I>s blog for the <I>Guardian</I>, has written articles for a range of publications including the BBC and <I>New Scientist</I>, and is also the author of <I>Most Wanted Particle</I>, shortlisted for Book of the Year by <I>Physics World</I>. He was awarded the Chadwick Medal of the Institute of Physics in 2013 for his pioneering experimental and phenomenological work in high-energy particle physics. For the last fifteen years, he has divided his time between London and Geneva.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Experiment
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3de30a6c